import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type GetPushResultsPath =
  operations['AdminNotificationController_getNotification']['parameters']['path'];
type GetPushResultsQuery =
  operations['AdminNotificationController_getNotification']['parameters']['query'];
type GetPushResultsHeaders =
  operations['AdminNotificationController_getNotification']['parameters']['header'];

interface GetPushResultsProps {
  path: GetPushResultsPath;
  query: GetPushResultsQuery;
  headers?: OmitGroupIdInHeader<GetPushResultsHeaders>;
}

type GetPushResultsResponse = components['schemas']['List$PushResult$t_B9FOT4MYGSolI9c2vZHA'];

export async function getPushResults({
  path,
  query,
  headers,
}: GetPushResultsProps): Promise<GetPushResultsResponse | false> {
  const response = await authenticateRequest<GetPushResultsResponse>({
    method: 'get',
    url: `/api/v1/admin/notifications/${path.notificationId}`,
    headers,
    params: query,
  });

  return response;
}

export type { GetPushResultsQuery, GetPushResultsResponse };
